import React, { Component, ErrorInfo, ReactNode } from "react";
import Alert from "@mui/material/Alert";
import { TFunction, withTranslation } from "react-i18next";
import { Result, ErrorDescription, ErrorResultType } from "../../../api/APIClient";

interface Props {
    children: ReactNode;
    errorMessage?: string;
    t: TFunction;
}

interface State {
    hasError: boolean;
    error: ErrorDescription | undefined;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false, error: undefined };
    }

    public static getDerivedStateFromError(_: Result): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: _.errorDescription };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {}

    public render() {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        if (this.state.hasError) {
            if (this.state.error !== undefined) {
                if (this.state.error.type === ErrorResultType.Unauthorized) {
                    return (
                        <Alert severity="warning">
                            {this.props.t("validationFormErrors.unauthorized")}:{" "}
                            {this.state.error.message}
                        </Alert>
                    );
                }
                return <Alert severity="error">{this.state.error.message}</Alert>;
            }
            return <h1>{this.props.errorMessage}</h1>;
        }

        return this.props.children;
    }
}

export default withTranslation("main")(ErrorBoundary);
